export default {
  title: 'My Alliances',
  alliance: 'Alliance',
  newRequests: 'New Alliance Requests',
  noNewRequests: 'No new requests',
  activeAlliances: 'Active Alliances',
  noActiveAlliances: 'No active alliances',
  highlightedRole: 'Highlighted role in your collaboration',
  chooseRole: 'Choose a role for this Alliance',
  remove: 'Remove',
  requestAlliance: 'Request an Alliance',
  searchPlaceholder: 'Search for a freelancer',
  sendRequest: 'Send request',
  sendMyRequest: 'Send my request',
  use_credit_and_send: 'Use 1 credit and send',
  closeFreelancerProfileModal: 'Close and return to Alliances',
  requestingAllianceTitle: 'Requesting Alliance',
  allianceMessageForLabel: 'Your Message for <bold>{{freelancerName}}</bold>',
  allianceRequestMessagePlaceholder: 'Enter your message here',
  allianceRequestError: 'Failed to send alliance request',
  sendingAllianceRequest: 'Sending alliance request...',
  backToAlliances: 'Back to my Alliances',
  cancelRequest: 'Cancel request',
  cancellingRequest: 'Cancelling request...',
  allianceRequestSentTitle: 'Request sent',
  allianceRequestSentMessage:
    '<bold>{{freelancerName}}</bold> has received your request. The request must be accepted to become an active Alliance.',
  allianceRequestCancelledTitle: 'Request cancelled',
  allianceRequestCancelledMessage:
    'The request to <bold>{{freelancerName}}</bold> has been cancelled.',
  allianceRequestCancelledError:
    'An unknown error occurred while cancelling the request. Try again or contact support.',
  myRequests: 'My Requests',
  noRequests: 'No requests',
  allianceAcceptTile: 'Accept Alliance Request',
  allianceAcceptSubtitle: 'From',
  confirmCancelMessage: 'Are you sure you want to cancel your alliance request to {{name}}?',
  allianceAcceptRequestMessage: 'Accept Alliance Request',
  allianceAcceptRequestMessageLabel: 'Message de {{ requesterName}}',
  allianceDeclineTile: 'Decline Alliance Request',
  allianceAcceptedTitle: 'Alliance accepted',
  allianceDeclinedTitle: 'Alliance declined',
  showRequest: 'Show request',
  confirmDeleteTitle: 'Confirm deletion',
  confirmDeleteMessage: 'Are you sure you want to delete your alliance with {{name}} ?',
  developer: 'Developer',
  designer: 'Designer',
  removingAlliance: 'Removing alliance...',
  allianceAcceptButtonLabel: 'Use 1 credit and accept',
  allianceDeclineButtonLabel: 'Decline request',
  allianceDeclineMessageDescription:
    'To decline the Alliance request from <bold>{{ requesterName }}</bold>, you must provide a brief explanation.',
  allianceDeclineMessagePlaceholder: 'Write a brief explanation to decline the request',
  allianceDeclineError: 'An error occurred while declining the alliance',
  allianceAcceptedMessage:
    'You can now participate in <bold>{{ requesterName }}</bold>’s submission projects from the <bold>Submission project creator</bold>.',
  allianceDeclinedMessage:
    'You declined the request from <bold>{{ requesterName}}</bold>. They will receive a notification with your message',
  manageQuotes: 'Manage my submissions',
  noFreelancersDetails:
    'This can happen if you already have an alliance with them or have already sent a request to the freelancers you searched for.',
  confirmCancelTitle: 'Confirm cancellation',
  confirmCancelButton: 'Confirm cancellation',
  cancelling: 'Cancelling...',
  AddAlliancesTexte: 'Add alliances to this submission',
  allianceRequestInsufficientCredits: 'Insufficient credits to send alliance request',
  confirmDeleteButton: 'Delete',
  deleting: 'Deleting...',
  alliances: 'Alliances',
} as const;
